module.exports = __webpack_public_path__ + "img/hzfp21.288246bd.png";